import { getStreakBattleRoyaleActiveTheme } from 'src/replicant/streakbattleroyale/streakbattleroyale.getters';
import { user } from 'src/StateObserver';
import { ViewOpts } from '@play-co/timestep-core/ui';
import { AssetGroup } from '@play-co/timestep-core';
import { ThemeProvider, createThemeProvider } from '../theme/ThemeProvider';
import { PositionType } from 'src/game/minigame/match2-timestep/lib/defs/types';
import { StreakBattleRoyaleTheme } from 'src/replicant/streakbattleroyale/streakbattleroyale.ruleset';
import { streakBattleRoyaleThemeV2 } from './themes/v2.theme';

export type StreakBattleRoyaleMapConfig = {
  background?: string;
  assetPrefix?: string;
  sectionWidth?: number;
  sectionHeight?: number;
  sectionColumns?: number;
  sectionRows?: number;
  rotation?: number;
  pivotX?: number;
  pivotY?: number;
  checkpoints: PositionType[];
  checkPointScales?: number[];
};

export type StreakBattleRoyaleThemeAssets = {
  panel_checkpoints: string;
  panel_info: string;
  panel_prize: string;
  panel_survivors: string;
  checkpoint_flag: string;
  checkpoint_plate: string;
  cloud_1: string;
  cloud_2: string;
  cloud_3: string;
  gem_banner: string;
  glare: string;
  ground: string;
  hero: string;
  message_bg: string;
  header: string;
  retry_flag: string;
  retry_flag2: string;
  spinner: string;
  sun_glare: string;
  trophy: string;
  you_made_it_en: string;
  you_made_it_ja: string;
  title_congratulations_en: string;
  title_congratulations_ja: string;
  title_event_en: string;
  title_event_ja: string;
  movieclip: string;

  // V2 assets
  intro_cloud: string;
  intro_mascot1: string;
  intro_mascot2: string;
  intro_mascot3: string;
  matchmaking_bg: string;
  chest: string;
  platform: string;
  home_label: string;
  subpanel_info: string;
  icon_death: string;
  frame_death: string;
};

export type StreakBattleRoyaleThemeAssetKey =
  keyof StreakBattleRoyaleThemeAssets;

export type StreakBattleRoyaleThemeStyles = {
  introPrize: ViewOpts;
  matchmakingHeader: ViewOpts;
};

export type StreakBattleRoyaleThemeStyleKey =
  keyof StreakBattleRoyaleThemeStyles;

export type StreakBattleRoyaleThemeProvider = {
  getMapConfig: () => StreakBattleRoyaleMapConfig;
  getStyle: (key: StreakBattleRoyaleThemeStyleKey) => ViewOpts;
  getAsset: (key: StreakBattleRoyaleThemeAssetKey) => string | undefined;
  getAssets: () => string[];
};

const themes = {
  lightning: streakBattleRoyaleThemeV2,
};

let themeProvider: ReturnType<typeof streakBattleRoyaleTheme> | null = null;
let currentTheme: StreakBattleRoyaleTheme | null = null;

/**
 * Retrieve the current bundle sale theme provider
 */
export function streakBattleRoyaleTheme(): ThemeProvider<
  StreakBattleRoyaleTheme,
  StreakBattleRoyaleThemeProvider
> {
  const activeTheme = getStreakBattleRoyaleActiveTheme(user());

  if (!themeProvider || currentTheme !== activeTheme) {
    currentTheme = activeTheme;
    themeProvider = createThemeProvider(themes, currentTheme);
  }

  return themeProvider;
}

export function getStreakBattleRoyaleAssetPaths() {
  const list = streakBattleRoyaleTheme().getAssets();
  return AssetGroup.constructURLs(list);
}
